import { useAppName, useLanguage, useSitecoreApiHost, useSitecoreApiKey } from '../../utils/sitecoreContext';
import { useGetLayoutServiceModelQuery } from '../apis/layoutServiceApi';
const DMM_API_MODEL_PATH = 'dmmapi/trimswithtransmissions/model';
const useFetchLayoutServiceModel = (sitecoreId, selectedModelYear, shouldFetch = true) => {
    const appName = useAppName();
    const language = useLanguage();
    const sitecoreApiHost = useSitecoreApiHost();
    const sitecoreApiKey = useSitecoreApiKey();
    const isSkipped = !sitecoreId || !shouldFetch;
    const { currentData, isFetching, error, isSuccess, isUninitialized } = useGetLayoutServiceModelQuery({
        url: `${sitecoreApiHost}/${DMM_API_MODEL_PATH}/${sitecoreId}/${selectedModelYear}`,
        params: {
            sc_apikey: sitecoreApiKey,
            sc_site: appName,
            sc_lang: language,
        },
    }, { skip: isSkipped });
    return {
        ...currentData,
        isFetching,
        hasError: !!error,
        isSuccess,
        isUninitialized,
        isSkipped,
    };
};
export default useFetchLayoutServiceModel;
